@use "styles" as *;

.me-card-radio {
  display: block;

  input {
    appearance: none;
    background-color: $color-background;
    margin: 0;

    font: inherit;
    color: $color-primary;
    width: $me-card-radio-size;
    height: $me-card-radio-size;
    border: $me-card-radio-border;
    border-radius: $me-card-radio-border-radius;

    &:checked {
      color: $color-background;
      background-color: $color-primary;
    }

    &::before {
      display: none;
      content: "";
      height: calc($me-card-radio-size / 2);
      width: calc($me-card-radio-size / 4);
      border-bottom: $me-card-radio-checkmark;
      border-right: $me-card-radio-checkmark;
      transform: translate(calc($me-card-radio-size / 3.75), 12%) rotate(45deg);
    }

    &:checked::before {
      display: block;
    }
  }
}
